// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".AllOrganizationsList-loadMore{display:flex;justify-content:center;padding:1rem 0}", "",{"version":3,"sources":["webpack://./components/AllOrganizationsList/index.sass"],"names":[],"mappings":"AACE,+BACE,YAAA,CACA,sBAAA,CACA,cAAA","sourcesContent":[".AllOrganizationsList\n  &-loadMore\n    display: flex\n    justify-content: center\n    padding: 1rem 0\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
